import React from "react";
import styled from "styled-components";
import { UIMatch, useMatches } from "react-router-dom";
import { RouterLink } from "components/ui/Link";
import UILabel from "components/ui/UILabel";
import { RouteHandle } from "types/router";
import { mediaMax } from "utils/theme";

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;

  ${mediaMax("lg")} {
    margin: 16px 0;
  }
`;

const Breadcrumbs = () => {
  const matches = useMatches() as UIMatch<unknown, RouteHandle>[];
  const currentMatch = matches[matches.length - 1];

  if (currentMatch.handle?.hideBreadcrumbs) return null;

  const breadcrumbs = matches
    .filter(
      (match, matchIndex) =>
        match.handle?.title &&
        !matches
          .slice(0, matchIndex)
          .some(
            (m) =>
              m.pathname.replace(/\/$/, "") ===
              match.pathname.replace(/\/$/, "")
          )
    )
    .map((match) => ({
      path: match.pathname,
      title: match.handle.title,
    }));
  const parent = currentMatch.handle?.parent;
  const parentBreadcrumb = parent
    ? {
        path: parent.path,
        title: parent.handle.title,
      }
    : null;

  if (parentBreadcrumb) {
    breadcrumbs.unshift(parentBreadcrumb);
  }

  if (breadcrumbs.length < 2) return null;

  return (
    <Wrapper>
      {breadcrumbs.map((breadcrumb, breadcrumbIndex) => {
        const { title } = breadcrumb;

        if (breadcrumbIndex === breadcrumbs.length - 1)
          return (
            <UILabel.Medium color="slate" key={title}>
              {title}
            </UILabel.Medium>
          );

        return (
          <React.Fragment key={title}>
            <RouterLink size="md" to={breadcrumb.path} color="azure">
              {title}
            </RouterLink>

            <UILabel.Medium color="dust">&gt;</UILabel.Medium>
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
};

export default Breadcrumbs;
